// pages/RepairPhonePage.js — "Repair Your Phone" quick enquiry (single screen).
// No backend: the visitor sends the pre-filled message from their own WhatsApp,
// so the shop gets their number automatically.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaArrowLeft } from 'react-icons/fa';
import SEO from '../components/SEO';
import './SellPhonePage.css';
import './RepairPhonePage.css';

const WHATSAPP_NUMBER = process.env.REACT_APP_SELL_WHATSAPP_NUMBER || '917891011841';

const PROBLEMS = [
  'Screen broken',
  'Battery drains fast',
  'Not charging',
  'Speaker / Mic',
  'Camera',
  'Water damage',
  'Phone is slow / hangs',
  'Not switching on',
  'Other issue',
];

const CITIES = ['Pune', 'Pimpri Chinchwad', 'Other city'];

const RepairPhonePage = () => {
  const [model, setModel] = useState('');
  const [problems, setProblems] = useState([]);
  const [note, setNote] = useState('');
  const [city, setCity] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleProblem = (p) =>
    setProblems((prev) => (prev.includes(p) ? prev.filter((x) => x !== p) : [...prev, p]));

  const valid = model.trim() && problems.length > 0;

  const buildText = () => {
    const lines = [
      'Hi JollyBaba! I need a mobile repair.',
      '',
      `*Phone:* ${model.trim()}`,
      `*Problem:* ${problems.join(', ')}`,
    ];
    if (note.trim()) lines.push(`*Details:* ${note.trim()}`);
    if (city) lines.push(`*City:* ${city}`);
    return lines.join('\n');
  };

  const whatsAppLink = () =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(buildText())}`;

  return (
    <div className="sell-page">
      <SEO
        title="Mobile Repair in Pune | JollyBaba Mobiles"
        description="Get your phone repaired at JollyBaba Mobiles, Deccan, Pune. Screen, battery, charging, water damage and more. Tell us the problem and get a quick quote on WhatsApp."
        keywords="mobile repair Pune, phone screen replacement Pune, battery replacement Pune, mobile repair Deccan, iPhone repair Pune, Samsung repair Pune"
        canonical="https://jollybaba.in/repair"
      />

      <div className="sell-hero">
        <Link to="/" className="sell-back">
          <FaArrowLeft /> Shop
        </Link>
        <h1>Repair your phone</h1>
        <p>Quick quote on WhatsApp</p>
      </div>

      <div className="sell-card">
        <label className="sell-label" htmlFor="repair-model">Phone model</label>
        <input
          id="repair-model"
          className="sell-input"
          type="text"
          placeholder="e.g. iPhone 13, Redmi Note 10"
          value={model}
          onChange={(e) => setModel(e.target.value)}
          maxLength={80}
        />

        <label className="sell-label">Problem</label>
        <div className="sell-chip-grid">
          {PROBLEMS.map((p) => (
            <button
              key={p}
              type="button"
              className={`sell-chip ${problems.includes(p) ? 'selected' : ''}`}
              onClick={() => toggleProblem(p)}
            >
              {p}
            </button>
          ))}
        </div>

        <label className="sell-label" htmlFor="repair-note">
          Anything else? <span className="sell-optional">(optional)</span>
        </label>
        <textarea
          id="repair-note"
          className="sell-input repair-textarea"
          placeholder="e.g. It fell last week, screen has lines"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          maxLength={300}
          rows={2}
        />

        <label className="sell-label" htmlFor="repair-city">
          City <span className="sell-optional">(optional)</span>
        </label>
        <select
          id="repair-city"
          className="sell-input sell-select"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        >
          <option value="">Select city</option>
          {CITIES.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>

        <div className="sell-nav">
          <a
            className={`sell-btn sell-btn-whatsapp repair-submit ${valid ? '' : 'repair-submit-disabled'}`}
            href={valid ? whatsAppLink() : undefined}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => { if (!valid) e.preventDefault(); }}
            aria-disabled={!valid}
          >
            <FaWhatsapp /> Get Repair Quote
          </a>
        </div>
        {!valid && (
          <p className="repair-hint">Enter your phone model and pick at least one problem.</p>
        )}
      </div>
    </div>
  );
};

export default RepairPhonePage;
